export const CONTACT_EMAIL = 'contacto@reango.app'
